import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Typography } from '@/lib/typography';
import { SHARED_UI_LABELS } from '@/config/task-display-config';

// R4 (15 Oct 2026): only live taxonomy codes (ruling 241). A test reads this list against backend/config/sia_config.json.
export const STARTUP_FILTER_SECTORS = ['All', 'FinTech', 'HealthTech', 'EdTech'];

export function FilterBar({ filters, onFilterChange }) {
  const sectors = STARTUP_FILTER_SECTORS;
  const stages = ['All', 'Pre-Seed', 'Seed', 'Series A', 'Series B', 'Series C+'];
  const statuses = ['All', 'Unassigned', 'Warm', 'Mandated', 'In-Market', 'Closed', 'Rejected'];


  return (
    <div className="flex items-center justify-between gap-4 p-4 bg-card rounded-lg border border-border" data-testid="filter-bar">
      <div className="flex items-center gap-4 flex-1">
        <div className="flex-1 max-w-[200px]">
          <label className="text-muted-foreground mb-1 block">Sector</label>
          <Select
            value={filters.sector || 'All'}
            onValueChange={(value) => onFilterChange('sector', value === 'All' ? '' : value)}
          >
            <SelectTrigger data-testid="filter-sector">
              <SelectValue placeholder={SHARED_UI_LABELS.selectSector} />
            </SelectTrigger>
            <SelectContent>
              {sectors.map((sector) => (
                <SelectItem key={sector} value={sector}>
                  {sector}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <div className="flex-1 max-w-[200px]">
          <label className="text-muted-foreground mb-1 block">Stage</label>
          <Select
            value={filters.stage || 'All'}
            onValueChange={(value) => onFilterChange('stage', value === 'All' ? '' : value)}
          >
            <SelectTrigger data-testid="filter-stage">
              <SelectValue placeholder={SHARED_UI_LABELS.selectStage} />
            </SelectTrigger>
            <SelectContent>
              {stages.map((stage) => (
                <SelectItem key={stage} value={stage}>
                  {stage}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <div className="flex-1 max-w-[200px]">
          <label className="text-muted-foreground mb-1 block">Status</label>
          <Select
            value={filters.status || 'All'}
            onValueChange={(value) => onFilterChange('status', value === 'All' ? '' : value)}
          >
            <SelectTrigger data-testid="filter-status">
              <SelectValue placeholder={SHARED_UI_LABELS.selectStatus} />
            </SelectTrigger>
            <SelectContent>
              {statuses.map((status) => (
                <SelectItem key={status} value={status}>
                  {status}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>
    </div>
  );
}
